import React from "react";
import classNames from "classnames";
import Head from "next/head";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';


// core components
import Header from "components/Header/Header";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import { Link, Grid } from "@material-ui/core";
import styles from "assets/jss/nextjs-material-kit/pages/landingPage.js";
import customStyles from "assets/jss/custom/customStyles.js";

const useStyles = makeStyles({
  ...styles,
  ...customStyles,
});

export async function getStaticProps() {
  return {
    props: {},
  };
}

export default function PressePage(props) {
  const dashboardRoutes = [];
  const { ...rest } = props;
  const classes = useStyles();

  const downloads = [{
    teaser: '/teaser/getasugar-logo.jpg',
    download: '/presse/getasugar-logo-lila.png',
    description: 'Format PNG',
    footer: '',
    title: 'getasugar Logo'
  }, {
    teaser: '/teaser/getasugar-logo.jpg',
    download: '/presse/getasugar-logo-lila.eps',
    description: 'Format EPS',
    footer: '',
    title: 'getasugar Logo'
  }, {
    teaser: '/teaser/getasugar-logo-negativ.jpg',
    download: '/presse/getasugar-logo-weiss.png',
    description: 'Format PNG',
    footer: '',
    title: 'getasugar Logo negativ'
  }, {
    teaser: '/teaser/getasugar-logo-negativ.jpg',
    download: '/presse/getasugar-logo-weiss.eps',
    description: 'Format EPS',
    footer: '',
    title: 'getasugar Logo negativ'
  }, {
    teaser: '/teaser/getasugar-smartphone.jpg',
    download: '/presse/getasugar-smartphone.jpg',
    description: 'Format JPEG',
    footer: '',
    title: 'getasugar auf dem Smartphone'
  }]

  const studies = [{
    teaser: '/teaser/sugardaddy-studie-2024.jpg',
    download: '/presse/sugardaddy-studie-2024.pdf',
    description: 'Format PDF',
    footer: '',
    title: 'Sugardaddy Studie 2024'
  }]

  const params = {
    title: "Presse",
    teaser: "",
  };

  const downloadEl = (dl) => {
    window.open(dl.download)
  }

  return (
    <div>
      <Head>
        <title>{params.title} | getasugar - das Sugar Dating Portal</title>
        <meta name="description" content={params.teaser} />
      </Head>
      <Header
        color="primary"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        {...rest}
      />
      <div className={classes.main} style={{ marginTop: "3em" }}>
        <div>
          <div className={classes.container}>
            <div className={classNames(classes.hasPaddingTop)}>
              <Grid container
                justify="center"
                className={classNames(
                  classes.hasPaddingTop,
                  classes.contentContainer,
                  classes.hasShadow
                )}
              >
                <Grid item xs={12} key='title'>
                  <h2 className={classes.h2}>{params.title}</h2>
                </Grid>

                <Grid item xs={12} key='press'>
                  <p>
                    Du recherchierst zum Thema Sugardating, Sugardaddys oder Sugarbabes? Gerne helfen wir Pressevertretern mit Informationen zum Thema, spannenden Insights oder Statistiken. Auch Statements und Einordnungen zu deinem Recherche Thema mit Sugardaddy Fokus sind möglich.
                  </p>
                  <p>
                    Schreib uns eine E-Mail mit deiner Anfrage oder deinem Anliegen. Wir tun unser Bestes, um dir zeitnah weiterzuhelfen.
                  </p>
                  <p>
                    Pressevertreter erreichen uns unter der folgenden E-Mailadresse:
                  </p>
                  <p>
                    <a href="mailto:presse@lovelyvibes.de">presse@lovelyvibes.de</a>
                  </p>
                </Grid>
              </Grid>
              <h3>Studien</h3>
              <Grid container spacing={2} style={{ paddingTop: "1em" }}>
                {studies.map((dl) => (
                  <Grid item xs={12} sm={6} md={4} lg={3}>
                    <Card>
                      <CardActionArea onClick={() => downloadEl(dl)}>
                        <CardMedia
                          image={dl.teaser}
                          title={dl.title}
                          style={{
                            height: "140px"
                          }}
                        />
                        <CardContent>
                          <Typography gutterBottom variant="body1" component="div">
                              {dl.title}
                          </Typography>
                          <Typography variant="body2" color="textSecondary" component="p">
                            {dl.description}
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                      <CardActions>
                        <Button size="small" color="primary" onClick={() => downloadEl(dl)}>
                          Download
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                ))}
              </Grid>
              <h3>Downloads</h3>
              <Typography>
                Hier aufgeführtes Bildmaterial, Logos und Screenshots zu getasugar.de können Journalisten, Kolumnisten und Bloggern in verschiedenen Medienkanälen frei verwenden, um über getasugar.de oder eine Pressemitteilung von getasugar zu berichten. Voraussetzung ist, dass der Inhalt nicht verändert wird.
              </Typography>
              <Grid container spacing={2} style={{ paddingTop: "1em" }}>
                  {downloads.map((dl) => (
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                      <Card>
                        <CardActionArea onClick={() => downloadEl(dl)}>
                          <CardMedia
                            image={dl.teaser}
                            title={dl.title}
                            style={{
                              height: "140px"
                            }}
                          />
                          <CardContent>
                            <Typography gutterBottom variant="body1" component="div">
                              {dl.title}
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                              {dl.description}
                            </Typography>
                          </CardContent>
                        </CardActionArea>
                        <CardActions>
                          <Button size="small" color="primary" onClick={() => downloadEl(dl)}>
                            Download
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
      <Footer withSignup={false} />
    </div>
  );
}
